import { createFileRoute } from '@tanstack/react-router';
import { LanesOverview } from '@uturn/portal/modules/lanes/pages/overview';

export const Route = createFileRoute('/_protected/lanes/')({
	component: LanesOverview,
});
